import React from "react";
import CompanyHotel from "@app/model/company_hotel/CompanyHotel";
import AlertExecution from "@app/model/alert/AlertExecution";
import CompetitorsPriceRateNotificationRowFragment
    from "@app/site/secured/alert-execution/fragment/competitors-price-rate/CompetitorsPriceRateNotificationRowFragment";
import CompetitorsPriceRateAlertExecutionNotificationOutput
    from "@app/model/alert/output/CompetitorsPriceRateAlertExecutionNotificationOutput";


const CompetitorsPriceRateNotificationsFragment: React.FunctionComponent<{
    companyHotel: CompanyHotel,
    alertExecution: AlertExecution,
    notificationOutputs: CompetitorsPriceRateAlertExecutionNotificationOutput[],
    isInDrawer?: boolean
}> = ({companyHotel, alertExecution, notificationOutputs, isInDrawer = false}) => {

    const days = alertExecution.alertOutput.alert.timeframe.days;
    const isMonths = days >= 30;
    const value = isMonths ? days/30 : days;

    return <div className={`mt-8 ${isInDrawer? "bg-gray-50" : "bg-white"} rounded-xl space-y-16 sm:space-y-20 lg:mx-0 p-4 sm:p-10`}>
        <div>
            <div className="flex items-center justify-between">
                <h2 className="text-base font-semibold leading-6 text-gray-900">
                    Next {value} {isMonths? "Month" : "Day"}{value > 1 ? 's' : ''}
                </h2>
            </div>
            <div className="mt-1 flow-root">
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full py-2 align-middle">
                        <table className="min-w-full divide-y divide-gray-300 text-gray-500">
                            <thead>
                            <tr>
                                <th scope="col"
                                    className="whitespace-normal py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Competitor
                                </th>
                                <th scope="col"
                                    className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Room
                                    Type
                                </th>
                                <th scope="col"
                                    className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Change
                                </th>
                                <th scope="col"
                                    className="whitespace-normal px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Room Found
                                </th>
                                <th scope="col"
                                    className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0 text-left text-sm font-semibold text-gray-900">Percentage
                                </th>
                            </tr>
                            </thead>
                            {notificationOutputs.map(notificationOutput => <CompetitorsPriceRateNotificationRowFragment
                                companyHotel={companyHotel} alertExecution={alertExecution} key={notificationOutput.notificationId}
                                notificationOutput={notificationOutput}/>)}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default CompetitorsPriceRateNotificationsFragment;